"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetChooser = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const react_1 = __importDefault(require("react"));
const DataChooser_1 = __importDefault(require("../DataChooser"));
const makeDataChooser_1 = __importDefault(require("../helpers/makeDataChooser"));
exports.AssetChooser = (0, makeDataChooser_1.default)((props) => {
    const { value, selectLabel = lib_i18n_1.default.t('select-asset') } = props, otherProps = __rest(props, ["value", "selectLabel"]);
    const valuesWithType = value === null || value === void 0 ? void 0 : value.map(s => (Object.assign(Object.assign({}, s), { type: DataType_1.default.ASSET })));
    return (react_1.default.createElement(DataChooser_1.default, Object.assign({}, otherProps, { selectLabel: selectLabel, type: [DataType_1.default.ASSET], value: valuesWithType })));
});
exports.default = exports.AssetChooser;
